export default __webpack_public_path__ + "static/media/small_advert.718d1e17.png";